import Dialog from '@material-ui/core/Dialog';
import { AppParams, AppPath } from 'AppRoutes';
import React from 'react';
import { Outlet, useMatch, useNavigate } from 'react-router-dom';
import { makeStyles, Theme } from '@material-ui/core/styles';

interface Props {}

const useStyles = makeStyles((theme: Theme) => ({
  paper: { minHeight: '60%' },
}));

const BoxListDialog = (props: Props) => {
  const classes = useStyles(props);
  const isLogPath = !!useMatch(`${AppPath.Log}/:${AppParams.LogId}`);
  const isOpen = isLogPath;
  const navigate = useNavigate();

  const onClose = () => navigate('/');

  return (
    <Dialog
      classes={{ paper: classes.paper }}
      maxWidth="lg"
      aria-labelledby="box-msgs-dialog"
      aria-describedby="box-msgs-dialog"
      open={isOpen}
      onClose={onClose}
    >
      <Outlet />
    </Dialog>
  );
};

export default BoxListDialog;
